import React from "react";
import _ from "lodash";

import { SeverityIndicator } from "../severityIndicator/SeverityIndicator";
import { HelpLink } from "../helpLink/HelpLink";
import { Mobile, NotMobile } from "../../hocs/Responsive";
import { SeverityTooltip } from "../severityTooltip/SeverityTooltip";
import { Tooltip } from "../tooltip/Tooltip";
import { NO_VALUE_PLACEHOLDER } from "../table/helpers";

import "./InfectionsList.scss";

export const InfectionsList = ({ infections }) => {
  if (_.isEmpty(infections)) {
    return <NotMobile>{NO_VALUE_PLACEHOLDER}</NotMobile>;
  }

  return (
    <div className={"infections-list"}>
      {_.map(infections, renderSeverityIndicator)}
    </div>
  );
};

const SeverityLink = ({ id, name, ...props }) => (
  <HelpLink
    section={`threat-list-${id}`}
    sectionTranslation={name}
    hasIcon={false}
    {...props}
  >
    {name}
  </HelpLink>
);

const renderSeverityIndicator = ({
  id,
  severity,
  name,
  description,
  notFullThreat = false,
}) => {
  if (notFullThreat) {
    return (
      <div key={id} className={"threat-id"}>
        {id}
      </div>
    );
  }

  const ariaId = `aria-describedby-${id}`;

  return (
    <SeverityIndicator key={id} severity={severity}>
      <NotMobile>
        <Tooltip
          content={
            <SeverityTooltip severity={severity} description={description} />
          }
          id={ariaId}
        >
          <SeverityLink id={id} name={name} aria-describedby={ariaId} />
        </Tooltip>
      </NotMobile>

      <Mobile>
        <SeverityLink id={id} name={name} />
      </Mobile>
    </SeverityIndicator>
  );
};
